import { createSlice } from "@reduxjs/toolkit";

const stepsSlice = createSlice({
  name: "steps",
  initialState: { value: 1 },
  reducers: {
    currentValue(state, action) {
      state.value = action.payload;
    },
  },
});

export { stepsSlice };
export const { currentValue } = stepsSlice.actions;
